import React from 'react';
import { CheckCircle, Lock } from 'lucide-react';
interface PaymentTrustProps {
  compact?: boolean;
}
export function PaymentTrust({
  compact = false
}: PaymentTrustProps) {
  return <div className={`w-full ${compact ? 'mt-6' : 'mt-2'}`} data-id="element-133">
      {/* Three trust pills */}
      <div className="flex flex-wrap justify-center items-center gap-x-5 gap-y-2 mb-4" data-id="element-134">
        <TrustPill label="Secure Checkout" data-id="element-135" />
        <TrustPill label="Instant Access" data-id="element-136" />
        <TrustPill label="7-Day Guarantee" data-id="element-137" />
      </div>

      {/* Disclaimer */}
      <p className="text-center text-gray-400 text-xs md:text-sm mb-5 leading-relaxed px-2" data-id="element-138">
        One-time payment. No hidden subscriptions. Instant digital delivery via
        Email.
      </p>

      {/* Payment icons row */}
      <div className="flex flex-wrap justify-center items-center gap-2 md:gap-2.5 mb-4" data-id="element-139">
        {/* Visa */}
        <PayCard data-id="element-140">
          <span className="font-bold italic tracking-tight text-base text-white" data-id="element-141">
            VISA
          </span>
        </PayCard>
        {/* Mastercard */}
        <PayCard data-id="element-142">
          <div className="flex items-center" data-id="element-143">
            <span className="w-3.5 h-3.5 rounded-full bg-[#EB001B]" data-id="element-144"></span>
            <span className="w-3.5 h-3.5 rounded-full bg-[#F79E1B] -ml-1.5 mix-blend-screen" data-id="element-145"></span>
          </div>
        </PayCard>
        {/* AMEX */}
        <PayCard data-id="element-146">
          <span className="font-bold tracking-widest text-[10px] text-white" data-id="element-147">
            AMEX
          </span>
        </PayCard>
        {/* Apple Pay */}
        <PayCard data-id="element-148">
          <span className="font-medium text-xs text-white flex items-center gap-0.5" data-id="element-149">
            <svg viewBox="0 0 24 24" className="w-3 h-3 fill-white" aria-hidden="true" data-id="element-150">
              <path d="M17.05 12.04c-.03-2.96 2.42-4.38 2.53-4.45-1.38-2.02-3.53-2.3-4.3-2.33-1.83-.19-3.57 1.08-4.5 1.08-.94 0-2.37-1.05-3.9-1.02-2 .03-3.85 1.16-4.88 2.95-2.08 3.61-.53 8.95 1.5 11.88.99 1.43 2.17 3.04 3.71 2.98 1.5-.06 2.06-.96 3.87-.96 1.81 0 2.32.96 3.9.93 1.61-.03 2.63-1.46 3.61-2.9 1.14-1.66 1.61-3.27 1.63-3.36-.04-.02-3.13-1.2-3.17-4.76zm-2.93-8.74c.83-1 1.39-2.4 1.23-3.79-1.19.05-2.64.79-3.49 1.79-.77.88-1.44 2.3-1.26 3.67 1.33.1 2.69-.67 3.52-1.67z" data-id="element-151" />
            </svg>
            Pay
          </span>
        </PayCard>
        {/* Google Pay */}
        <PayCard data-id="element-152">
          <span className="font-medium text-xs text-white flex items-center gap-0.5" data-id="element-153">
            <span className="font-bold text-[#4285F4]" data-id="element-154">G</span>
            <span data-id="element-155">Pay</span>
          </span>
        </PayCard>
        {/* PayPal */}
        <PayCard data-id="element-156">
          <span className="font-bold italic text-xs" data-id="element-157">
            <span className="text-[#003087]" data-id="element-158">Pay</span>
            <span className="text-[#009CDE]" data-id="element-159">Pal</span>
          </span>
        </PayCard>
      </div>

      {/* Accept-line */}
      <p className="text-center text-gray-500 text-[11px] md:text-xs mb-4" data-id="element-160">
        We accept credit cards, debit cards, and PayPal via Shopify Secure
      </p>

      {/* Shopify Secure badge */}
      <div className="flex justify-center" data-id="element-161">
        <div className="inline-flex items-center gap-2 bg-dark-card border border-gold/20 rounded-full px-4 py-2 shadow-[0_0_15px_rgba(212,175,55,0.08)]" data-id="element-162">
          <div className="w-5 h-5 rounded-full bg-[#5E8E3E] flex items-center justify-center flex-shrink-0" data-id="element-163">
            <Lock className="w-2.5 h-2.5 text-white" strokeWidth={3} data-id="element-164" />
          </div>
          <span className="text-white text-[10px] md:text-xs font-bold tracking-[0.15em] uppercase" data-id="element-165">
            100% Secured by <span className="text-[#95BF47]" data-id="element-166">Shopify</span>{' '}
            Secure
          </span>
        </div>
      </div>
    </div>;
}
function TrustPill({
  label
}: {
  label: string;
}) {
  return <div className="flex items-center gap-1.5" data-id="element-167">
      <CheckCircle className="w-4 h-4 text-gold flex-shrink-0" data-id="element-168" />
      <span className="text-white text-xs md:text-sm font-semibold tracking-wide" data-id="element-169">
        {label}
      </span>
    </div>;
}
function PayCard({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="bg-white/[0.04] border border-white/15 rounded px-2.5 py-1.5 h-8 min-w-[44px] flex items-center justify-center hover:border-gold/30 transition-colors" data-id="element-170">
      {children}
    </div>;
}